import { Link } from "react-router-dom";
import { BedDouble, Bath, Maximize, MapPin, Zap } from "lucide-react";
import { mediaUrl, formatPrice } from "@/lib/api";

const statusColor = {
  Disponibile: "bg-[#166534]",
  Riservato: "bg-[#854D0E]",
  Venduto: "bg-[#7A1F1F]",
};

export const PropertyCard = ({ property, index = 0 }) => {
  const cover = property.images?.[0]?.url;
  const unavailable = ["Venduto", "Affittato", "Non più disponibile"].includes(property.status);
  const statusLabel = unavailable ? "Non più disponibile" : property.status;
  return (
    <Link
      to={`/immobili/${property.slug}`}
      className={`group block bg-white rounded-2xl overflow-hidden border border-[#DCE6EF] hover:shadow-xl transition-shadow duration-300 ${unavailable ? "opacity-60 hover:opacity-100" : ""}`}
      data-testid={`property-card-${property.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#E3ECF3]">
        {cover ? (
          <img src={mediaUrl(cover)} alt={property.title} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${unavailable ? "grayscale group-hover:grayscale-0 transition-[filter]" : ""}`} loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#A9B4C1] font-mono text-sm">Nessuna foto</div>
        )}
        <div className="absolute top-3 left-3 flex gap-2">
          <span className={`${unavailable ? "bg-[#566476]" : (statusColor[property.status] || "bg-[#1B2A41]")} text-white text-[11px] font-semibold px-2.5 py-1 rounded-full`} data-testid={`property-status-${property.id}`}>{statusLabel}</span>
          <span className="bg-white/90 text-[#1B2A41] text-[11px] font-semibold px-2.5 py-1 rounded-full">{property.contract}</span>
        </div>
        {property.energy_class && (
          <span className="absolute top-3 right-3 bg-[#E0961C] text-white text-[11px] font-bold px-2 py-1 rounded-md flex items-center gap-1"><Zap className="w-3 h-3" />{property.energy_class}</span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-1.5 text-[#2472C8] text-xs font-mono uppercase tracking-wider mb-2">
          <MapPin className="w-3.5 h-3.5" /> {property.zone}
        </div>
        <h3 className="font-heading font-semibold text-[#1B2A41] text-lg leading-snug line-clamp-2 group-hover:text-[#2472C8] transition-colors">{property.title}</h3>
        <div className="font-mono text-2xl font-semibold text-[#1B2A41] mt-3">{formatPrice(property.price)}</div>
        <div className="flex items-center gap-4 mt-4 pt-4 border-t border-[#EAF0F6] text-sm text-[#566476]">
          {property.rooms ? <span className="flex items-center gap-1.5"><BedDouble className="w-4 h-4" />{property.rooms} locali</span> : null}
          {property.bathrooms ? <span className="flex items-center gap-1.5"><Bath className="w-4 h-4" />{property.bathrooms}</span> : null}
          {property.surface ? <span className="flex items-center gap-1.5"><Maximize className="w-4 h-4" />{property.surface} m²</span> : null}
        </div>
      </div>
    </Link>
  );
};
